
<template>
    <van-nav-bar
        title="提报详情"
        left-text="返回"
        left-arrow
        style="margin-bottom: 10px"
        @click-left="onClickLeft"
    />
    <van-cell title="提报单号" style="border-radius: 15px 15px 0px 0px;" >
        <span>{{ Details_View.id }}</span>
    </van-cell>
    <van-cell title="提报状态" v-if="Details_View.state == 'N'">
        <span style="color: red">未回复</span>
    </van-cell>
    <van-cell title="提报状态" v-else>
        <span style="color: blue">已回复</span>
    </van-cell>
    <van-cell title="提报标题" >
        <span>{{ Details_View.title }}</span>
    </van-cell>
    <van-cell title="提报类型" v-if="Details_View.type == 1">
        <span style="color: red">匿名提报</span>
    </van-cell>
    <van-cell title="提报类型" v-else>
        <span style="color: blue">署名提报</span>
    </van-cell>
    <van-cell title="提报人" v-if="Details_View.type == 2">
        <span>{{ Details_View.name }}</span>
    </van-cell>
    <van-cell title="提报电话" v-if="Details_View.type == 2">
        <span>{{ Details_View.phone }}</span>
    </van-cell>
    <van-cell title="发生日期" >
        <span>{{ Details_View.happen_Date }}</span>
    </van-cell>
    <van-field
            :placeholder="Details_View.description"
            label="提报内容"
            autosize
            type="textarea"
            readonly
            label-align="top"
    />
    <van-cell title="提报时间" >
        <span>{{ Details_View.submit_Datetime }}</span>
    </van-cell>
    <van-field
            :placeholder="Details_View.feedback"
            v-if="Details_View.state == 'Y'"
            label="回复内容"
            autosize
            type="textarea"
            readonly
            label-align="top"
    />
    <van-cell title="回复时间" v-if="Details_View.state == 'Y'">
        <span>{{ Details_View.p_Datetime }}</span>
    </van-cell>
</template>
<script setup>
import {onMounted, ref} from "vue";
import { useRoute } from "vue-router";
import {closeToast, showLoadingToast} from "vant";
import axios from "axios";

const Details_View = ref([]);
const route = useRoute();
const TS_ID = ref();
const onClickLeft = () => history.back();
onMounted(() => {
    window.document.title = '宁波万汇投诉建议平台'
    if (typeof(route.query.id) != "undefined"){
        TS_ID.value = route.query.id
    }else {
        TS_ID.value = location.href.split('TS_ID=')[1].split(',')[0]
    }
    showLoadingToast({
        overlay:true,
        forbidClick:true,
        message: '加载中...',
        duration:0
    });
    axios.post("https://afa.activa-leisure.com/lj/back/view_complaint",
        {
            TS_ID: TS_ID.value,
            state:2,
        },
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result => {
        closeToast();
        Details_View.value = result.data.data[0]
        console.log(Details_View.value);
    })
})
</script>
<style scoped>

</style>